module.exports = __webpack_public_path__ + "static/media/ill_ont_i_halsen.335fa12e.svg";